/**
 * Debug logger.
 *
 * Logs are suppressed unless `REACT_APP_DEBUG=true` at build time, or
 * `window.__MINDSHARE_DEBUG__ = true` is set at runtime (DevTools console).
 * Use in place of `console.log` for development-only diagnostics. Error
 * and warning output should still use `console.error`/`console.warn`.
 */

const envFlag = process.env.REACT_APP_DEBUG === 'true';

const isDebugEnabled = (): boolean => {
  if (envFlag) return true;
  if (typeof window !== 'undefined') {
    const runtime = (window as unknown as { __MINDSHARE_DEBUG__?: boolean }).__MINDSHARE_DEBUG__;
    if (runtime === true) return true;
  }
  return false;
};

export const debugLog = (...args: unknown[]): void => {
  if (!isDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.log(...args);
};
